import React, { useRef } from 'react';

import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';
import Svg, { Defs, Path, Pattern, Rect } from 'react-native-svg';

import { primitive } from 'styles/constants';

const CROWN_NATIVE_W = 28;
const CROWN_NATIVE_H = 30;
const CROWN_WIDTH = 28;
const SCALE = CROWN_WIDTH / CROWN_NATIVE_W;
const CROWN_HEIGHT = CROWN_NATIVE_H * SCALE;
const GAP_X = 0;
const GAP_Y = 8;
const TILE_W = CROWN_WIDTH + GAP_X;
const TILE_H = CROWN_HEIGHT + GAP_Y;

// Path from Figma — stroke-only crown, 6.175° rotation already baked into path data
const CROWN_PATH =
  'M0.765467 7.28594C0.559919 5.32285 2.68498 3.97297 4.36156 5.00166L11.2289 9.21523C12.2749 9.85702 13.6363 9.59153 14.3686 8.60292L19.4732 1.71208C20.5642 0.239305 22.8326 0.504993 23.554 2.19005L26.9287 10.0728C27.403 11.1809 28.6277 11.7568 29.7799 11.4136L38.0809 8.94016C39.9237 8.39108 41.6154 10.1554 40.9999 11.9844L35.7419 27.6076C35.3857 28.6664 34.345 29.3346 33.2393 29.215L4.61791 26.1184C3.50795 25.9983 2.63246 25.1168 2.51567 24.0018L0.765467 7.28594Z';

interface CrownPatternBackgroundProps {
  style?: StyleProp<ViewStyle>;
}

export const CrownPatternBackground = ({ style }: CrownPatternBackgroundProps) => {
  const patternId = useRef(`crown-bg-${Math.random().toString(36).slice(2)}`).current;

  return (
    <View style={[styles.container, style]}>
      {/* @ts-ignore - style type mismatch on web */}
      <Svg width="100%" height="100%" style={StyleSheet.absoluteFillObject}>
        {/* @ts-ignore - Defs children not typed for web */}
        <Defs>
          <Pattern
            id={patternId}
            x="0"
            y="0"
            width={TILE_W * 2}
            height={TILE_H * 2}
            patternUnits="userSpaceOnUse"
            patternTransform="rotate(6.175, 0, 0)"
          >
            <Path
              transform={`scale(${SCALE})`}
              d={CROWN_PATH}
              fill="none"
              stroke="white"
              strokeOpacity={0.1}
              strokeWidth={1.5 / SCALE}
            />
            <Path
              transform={`translate(${TILE_W}, ${TILE_H}) scale(${SCALE}) rotate(180, ${
                CROWN_NATIVE_W / 2
              }, ${CROWN_NATIVE_H / 2})`}
              d={CROWN_PATH}
              fill="none"
              stroke="white"
              strokeOpacity={0.1}
              strokeWidth={1.5 / SCALE}
            />
          </Pattern>
        </Defs>
        <Rect width="100%" height="100%" fill={`url(#${patternId})`} />
      </Svg>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    backgroundColor: primitive.$bbqBrown,
    overflow: 'hidden',
  },
});
